import { FormModal as Modal } from 'src/components/forms';
import React from 'react';
import useConfirm from '../../hooks/useConfirm';
import { Group, Text } from '@mantine/core';
import { Button } from '@quantum-ecosystem/ui-toolkit';
import { Translate } from 'react-auto-translate';

const ConfirmDialog = () => {
	const { onConfirm, onCancel, confirmState } = useConfirm();

	return (
		<Modal
			opened={confirmState.show}
			onClose={onCancel}
			title={<Translate>Delete Confirmation</Translate>}
		>
			<Text size="md" c="dimmed">
				{confirmState?.text ? <Translate>{confirmState.text}</Translate> : ''}
			</Text>
			<Group mt="md" gap="xs" align="center" justify="flex-end">
				<Button variant="outline-secondary" onClick={onCancel}>
					<Translate>No</Translate>
				</Button>
				<Button variant="danger" onClick={onConfirm}>
					<Translate>Yes</Translate>
				</Button>
			</Group>
		</Modal>
	);
};
export default ConfirmDialog;
